var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 61,
    viewBox: "0 0 84 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77329 21.3446V28.9289H5.8893V30.3375H1.77329V41.1723H-0.176392V19.936H6.21424V21.3446H1.77329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2549 41.1723V19.936H15.2046V41.1723H13.2549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3612 21.3446V41.1723H24.4115V21.3446H22.1368V19.936H28.7441V21.3446H26.3612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4671 19.936C41.5251 19.936 42.3916 20.3694 42.3916 22.3197V27.7371C42.3916 28.8206 41.9583 29.6874 40.7669 29.9041C42.175 30.1208 42.4999 31.0959 42.4999 32.1794V41.1723H40.6586V32.071C40.6586 30.9875 40.3336 30.6625 39.5754 30.6625H37.6257V41.1723H35.676V19.936H39.4671ZM37.6257 29.254H39.4671C40.2253 29.254 40.5502 28.8206 40.5502 27.8455V22.7531C40.5502 21.6696 40.2253 21.3446 39.3588 21.3446H37.6257V29.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7104 41.0639L78.6776 25.0284V41.0639H76.7279V19.8277H79.0025L82.0354 35.8632V19.8277H83.9851V41.0639H81.7104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9391 19.1776C53.7651 19.1776 48.7826 24.1616 48.7826 30.3374C48.7826 36.5133 53.7651 41.4973 59.9391 41.4973C66.1131 41.4973 71.0956 36.5133 71.0956 30.3374C71.0956 24.1616 66.1131 19.1776 59.9391 19.1776ZM59.9391 36.5133C56.5813 36.5133 53.7651 33.8046 53.7651 30.3374C53.7651 26.9786 56.473 24.1616 59.9391 24.1616C63.2969 24.1616 66.1131 26.8703 66.1131 30.3374C66.1131 33.6962 63.4052 36.5133 59.9391 36.5133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8151 39.9655L45.5 60.7683H47.4497L56.4399 40.6156C55.8983 40.5073 55.3567 40.2906 54.8151 39.9655Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6374 0L56.9065 35.6465C57.4481 35.9716 57.9897 36.1883 58.5312 36.2966L73.5871 0H71.6374Z",
    fill: "#E40031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9066126d89e2c143256f1ab039a0469f.svg";
export { ForwardRef as ReactComponent };